module.exports = __webpack_public_path__ + "img/tickets-icon.14b88b43.svg";